<iframe id="myIFrame" [attr.src]="url" title="iframeOldBO"></iframe>
